module.exports = "https://static.wagwalking.com/_next/static/images/walker-gallery-placeholder-59843b73dc7b1639bfddee468e41e3cd.png";